import React, { Component } from "react";
import PropTypes from "prop-types";

const Video = props => {
	return (
		props.show && (
			<div
				className="video-component-wrapper"
				style={{ position: props.fixed ? "fixed" : "absolute" }}
				onClick={props.onClose}
			>
				<div
					className="video-component"
					style={{ width: props.width + "px", height: props.height + "px" }}
				>
					<div className="video-component--description">{props.description}</div>
				</div>
			</div>
		)
	);
};

Video.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	description: PropTypes.any,
	onClose: PropTypes.func,
	show: PropTypes.bool
};

Video.defaultProps = {
	width: 560,
	height: 315,
	show: false
};

export default Video;
